import { OrderUnitOfMeasure } from '@treadinc/horizon-api-spec';

import { trimmedOrUndefined } from './importPayload';

export const VALID_ORDER_UNITS_OF_MEASURE = Object.values(OrderUnitOfMeasure);

/**
 * Canonical spelling of a unit a user typed into a CSV cell, or undefined when it matches
 * no known unit. Matching ignores case and internal spacing so "cubic meter" resolves.
 */
export function normalizeUnitOfMeasure(input: string | undefined) {
  const cleaned = trimmedOrUndefined(input)?.replace(/\s/g, '').toUpperCase();

  return cleaned
    ? VALID_ORDER_UNITS_OF_MEASURE.find((unit) => unit.toUpperCase() === cleaned)
    : undefined;
}
